import { Component, OnInit } from '@angular/core';
import { BaseComponent } from '../classes/BaseComponent';
import { InternationalizationHelper } from '../helpers/InternationalizationHelper';

declare var reviews: any;

@Component({
  selector: 'app-user-reviews',
  templateUrl: './user-reviews.component.html',
  styleUrls: ['./user-reviews.component.scss']
})
export class UserReviewsComponent extends BaseComponent implements OnInit {

  reviewCount: number = 3;
  allReviews: any[] = null;
  reviews: any[] = [];

  constructor() {
    super();

    const reviewsForLanguage = reviews[InternationalizationHelper.getTwoCharactersLanguage()];
    if(reviewsForLanguage) {
      this.allReviews = reviewsForLanguage;
    }
    else {
      this.allReviews = reviews[InternationalizationHelper.defaultLanguage]
    }

    const pickedIndex = [];
    while(pickedIndex.length < this.reviewCount) {
      const randomIndex = Math.floor(Math.random() * this.allReviews.length);
      if(!pickedIndex.includes(randomIndex)) {
        pickedIndex.push(randomIndex);
        this.reviews.push(this.allReviews[randomIndex]);
      }
    }

  }

  ngOnInit() {
  }

}
